export default __webpack_public_path__ + "static/media/depressed.8022eb60.png";